var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasurementsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7508 12.7508C17.9373 12.9366 18.0852 13.1574 18.1861 13.4005C18.2871 13.6436 18.3391 13.9042 18.3391 14.1675C18.3391 14.4307 18.2871 14.6913 18.1861 14.9344C18.0852 15.1776 17.9373 15.3983 17.7508 15.5841L15.5841 17.7508C15.3983 17.9373 15.1776 18.0852 14.9344 18.1861C14.6913 18.2871 14.4307 18.3391 14.1675 18.3391C13.9042 18.3391 13.6436 18.2871 13.4005 18.1861C13.1574 18.0852 12.9366 17.9373 12.7508 17.7508L2.25081 7.25081C1.87628 6.87446 1.66602 6.3651 1.66602 5.83414C1.66602 5.30319 1.87628 4.79383 2.25081 4.41748L4.41748 2.25081C4.79383 1.87628 5.30319 1.66602 5.83414 1.66602C6.3651 1.66602 6.87446 1.87628 7.25081 2.25081L17.7508 12.7508Z",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.084 10.4167L13.7507 8.75",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58398 7.91667L11.2507 6.25",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08398 5.41667L8.75065 3.75",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.584 12.9167L16.2507 11.25",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementsIcon);
export default __webpack_public_path__ + "static/media/measurements-icon.4ba6d075c03ec75c6bbbf0af3dfda930.svg";
export { ForwardRef as ReactComponent };